import React from 'react';
import {
  Container,
  Card,
  Image,
  SimpleGrid,
  Box,
  AspectRatio
} from '@chakra-ui/react';

import {
    AccordionRoot,
    AccordionItem,
    AccordionItemTrigger,
    AccordionItemContent
  } from "../../components/ui/accordion.jsx";
import HomeLayout from '../../components/layouts/homelayout'
import { ChevronDown } from 'lucide-react';

import wellbeingHeroImg from '../../components/ui/ourcompany/wellbeing/wellbeing_banner_1.jpg';

import communityImg from '../../components/ui/ourcompany/wellbeing/community_wellness.jpg';
import physicalImg from '../../components/ui/ourcompany/wellbeing/physical_wellbeing.jpg';
import socialImg from '../../components/ui/ourcompany/wellbeing/social_wellbeing.jpg';
import careerImg from '../../components/ui/ourcompany/wellbeing/career_wellbeing.jpg';
import moreImg from '../../components/ui/ourcompany/wellbeing/and_more_wellbeing.jpg';
import financialImg from '../../components/ui/ourcompany/wellbeing/financial_wellbeing.png';

export default function Wellbeing() {

    const items = [
        { name: "Physical", description: "Our robust benefits support employees in good health in their daily life through medical, dental, vision, mental health, voluntary benefit programs, and more.", url: `${(physicalImg)}`},
        { name: "Social/ Emotional", description: "We believe in enabling positive relationships and connections across our global workforce through our Employee Resource Networks (ERNs), onsite and virtual events, and activities.", url: `${(socialImg)}` },
        { name: "Financial", description: "CSC strives to support employees in managing their financial life, through competitive compensation programs, retirement benefits with generous company match, paid parental leave, life insurance, disability benefits, financial tools, and education.", url: `${(financialImg)}` },
        { name: "Career", description: "Employees are empowered to take charge of their careers through learning and development opportunities and resources to enable a high-performance culture and growth.", url: `${(careerImg)}` },
        { name: "Community", description: "CSC fosters engagement in the communities where we live and work through social responsibility, volunteering, and donation matching.", url: `${(communityImg)}`},
        { name: "And more!", description: "Generous time off, employee discounts, lifestyle reimbursement accounts, and more!", url: `${(moreImg)}`},
      ]

  return (
    <HomeLayout align="left">
      <title>Wellbeing and Benefits</title>
      <meta name="description" content="Employee wellbeing is the foundation of our Total Rewards philosophy." />
       <div className='hero-main height-100 page-banner'>
        <div className='hero-main__container'>
          <div className='hero-main__inner-container'>
            <div className='hero-main__inner center-left is-top'>
              <div className='container'>
                <div className='hero-main__content text-balance'>
                  <h1>We ignite human potential for growth.</h1>
                </div>
              </div>
            </div>
            <div className='hero-main__video-container'>
                <img src={wellbeingHeroImg} alt='' />
            </div>
            <div className='hero-main__caret-wrapper'>
              <figure className='hero-main__caret'>
                <ChevronDown />
              </figure>
            </div>
            <div className='hero-main__overlay'></div>
          </div>
        </div>
      </div>
        <Container maxW={'6xl'} className='flow' py={12}>
            <Box className='mw-prose flow' marginInline={'auto'}>
                <p>
                    At Columbia Sportswear Company (CSC), our mission is to connect active people with their passions. And we know that passions carry you far beyond your work.
                </p>
                <p>
                    To get the most out of life and work, no matter where your passions take you, you need to feel your best. Our wellbeing programs are designed to give employees the tools and resources they need to ignite their potential for growth, while living healthy and balanced lives. Life is a grand adventure – live it well!
                </p>
            </Box>
            
            <SimpleGrid columns={{ base: 1, md: 2, lg: 3}} gap={"var(--space-m)"} css={{"--flow-space": "var(--space-l)"}}>

                {items.map((item, index) => (
                    <Card.Root maxW="100%" overflow="hidden" key={index} borderRadius={"none"}>
                        <AspectRatio ratio={16 / 8}>
                            <Image
                                src={item.url}
                                alt=""
                            />
                        </AspectRatio>
                        
                        <Card.Body gap="2">
                            <AccordionRoot variant={"plain"} collapsible>
                                <AccordionItem>
                                    <AccordionItemTrigger >
                                        <h3 style={{"font-size": "var(--step-1)"}}>{item.name}</h3>
                                    </AccordionItemTrigger>

                                    <AccordionItemContent>
                                        {item.description}
                                    </AccordionItemContent>
                                </AccordionItem>
                            </AccordionRoot>
                        </Card.Body>
                    </Card.Root>
                ))}
            </SimpleGrid>
      </Container>
    </HomeLayout>
  );
}
